import { render, staticRenderFns } from "./PgaSendEmailToPermissions.vue?vue&type=template&id=6fbdfdb4&"
import script from "./PgaSendEmailToPermissions.vue?vue&type=script&lang=ts&"
export * from "./PgaSendEmailToPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VDialog,VDivider,VIcon,VSpacer,VSystemBar})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fbdfdb4')) {
      api.createRecord('6fbdfdb4', component.options)
    } else {
      api.reload('6fbdfdb4', component.options)
    }
    module.hot.accept("./PgaSendEmailToPermissions.vue?vue&type=template&id=6fbdfdb4&", function () {
      api.rerender('6fbdfdb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Shared/Email/PgaSendEmailToPermissions.vue"
export default component.exports